<script>
export default {
	name: 'CheckboxTableSelectOne',
	
	components: {
	
	},
	
	data() {
		return {
			item:{},
			datas:[],
			isSelected:false
		}
	},
	
	props: {'id': Number, 'selectedId': Boolean, 'selectedItemStore': Object, 'allSelectedItems': Array, 'dataList': Array },
	emits: [],

	mounted:function(){
		this.datas=this.dataList;
		this.item=this.selectedItemStore;
		if(this.allSelectedItems.indexOf(this.id)>=0){
			this.isSelected=true;
		}
	},
	
	methods: {
		handleClick(id){
			if(this.allSelectedItems.indexOf(id)===-1){
				var index = this.datas.findIndex(item => item.id==id);
				//oznacim  v dataList
				if(index>=0){
					this.datas[index].selectedId=true;
					this.item.addSelectedItems(id);
				}
				
			}else{
				var indexToRemove = this.allSelectedItems.indexOf(id);
				
				//oznacim odstranenie v dataList
				var indexx = this.datas.findIndex(item => item.id==id); 
				if(index>=0){
					this.datas[indexx].selectedId=false;
					this.item.deleteSelectedItems(indexToRemove);
				}
			}
			this.$emit('changeSelected',this.datas)
		}
	},	
	
	watch: {
		allSelectedItems() {
			if(this.allSelectedItems.indexOf(this.id)>=0){
				this.isSelected=true;
			}else{
				this.isSelected=false;
			}
		},
		selectedId() {
			if(this.selectedId==true){
				this.isSelected=true;
			}else{
				this.isSelected=false;
			}
		},
		dataList() {
			this.datas=this.dataList;
		},
	},

	computed:{
		
	},
	
}
</script>

<template>
	<div>
		<div class="form-check">
			<label class="form-check-label">
			<input v-model='isSelected' class="form-check-input" type="checkbox" v-on:change="handleClick(id);">
			<span class="form-check-sign"><span class="check"></span></span>
			</label>
		</div>	
	</div>
</template>


